function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import { internationalizedArrayOptionalImage, internationalizedArraySimpleBlockContent, internationalizedArrayString, sanityReference, arrayEntry, documentSlug } from '../fragments/index.js';
import researchGroup from './researchGroup.js';
import taxonomy from './taxonomy.js';
import researchPlatform from './researchPlatform.js';
var schema = defineDocument('disease', {
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    name: {
        title: 'Name',
        type: 'internationalizedArrayString'
    },
    image: {
        title: 'Image',
        type: 'internationalizedArrayOptionalImage'
    },
    content: {
        title: 'Content',
        description: 'Additional information displayed in the popup',
        type: 'internationalizedArraySimpleBlockContent'
    },
    areas: {
        title: 'Areas',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'taxonomy'
                    }
                ],
                options: {
                    filter: 'type == $type',
                    filterParams: {
                        type: TaxonomyType.DISEASE_AREA
                    }
                }
            }
        ]
    },
    linkedResearchContent: {
        title: 'Research groups and platforms',
        type: 'array',
        of: [
            {
                type: 'reference',
                to: [
                    {
                        type: 'researchGroup'
                    },
                    {
                        type: 'researchPlatform'
                    }
                ]
            }
        ]
    }
}, [
    taxonomy.schema.taxonomy,
    researchGroup.schema.researchGroup,
    researchPlatform.schema.researchPlatform,
    {},
    {},
    {}
]);
var validator = z.object({
    slug: documentSlug.validator,
    name: internationalizedArrayString.validator,
    image: internationalizedArrayOptionalImage.validator,
    content: internationalizedArraySimpleBlockContent.validator,
    areas: z.array(sanityReference.validator.merge(arrayEntry.validator)),
    linkedResearchContent: z.array(sanityReference.validator.merge(arrayEntry.validator))
}).partial();
schema.disease;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=disease.js.map